import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { UserFormData, userSchema } from '../../pages/UserManagement';
import FormInput from '../FormsInput/FormInput';
import { ADMIN_ROLE_NAME, REPORTING_ONLY_ROLE_NAME, RETURN_MAIL_TEAM_ROLE_NAME } from '../../types/Role';
type Props = {
  onAdd: (data: UserFormData) => void;
  isCreatingLoading: boolean;
};
const AddUserModal = (props: Props) => {
  const { onAdd, isCreatingLoading } = props;
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, touchedFields },
  } = useForm<UserFormData>({
    resolver: zodResolver(userSchema),
    defaultValues: { firstName: '', lastName: '', email: '', role: REPORTING_ONLY_ROLE_NAME },
    mode: 'onTouched',
  });

  const onSubmit = async (data: UserFormData) => {
    await onAdd(data);
    reset();
  };
  const closeModal = () => {
    (document.getElementById('add_modal') as HTMLFormElement)?.close();
  };
  return (
    <dialog id="add_modal" className="modal">
      <div className="modal-box">
        <h3 className="font-bold text-lg">Add New User</h3>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-2">
          <FormInput
            label="First Name"
            name="firstName"
            type="string"
            register={register('firstName')}
            errors={errors.firstName}
            touchedField={touchedFields.firstName}
            placeholder="first name"
            required={true}
          />
          <FormInput
            label="Last Name"
            name="name"
            type="string"
            register={register('lastName')}
            errors={errors.lastName}
            touchedField={touchedFields.lastName}
            placeholder="last name"
            required={true}
          />
          <FormInput
            label="Email"
            name="email"
            type="email"
            register={register('email')}
            errors={errors.email}
            touchedField={touchedFields.email}
            placeholder="email"
            required={true}
          />
          <select {...register('role')} className="select select-bordered w-full">
            <option value={REPORTING_ONLY_ROLE_NAME}>{REPORTING_ONLY_ROLE_NAME}</option>
            <option value={RETURN_MAIL_TEAM_ROLE_NAME}>{RETURN_MAIL_TEAM_ROLE_NAME}</option>
            <option value={ADMIN_ROLE_NAME}>{ADMIN_ROLE_NAME}</option>
          </select>

          <div className="modal-action">
            <button type="submit" className="btn btn-success" disabled={isCreatingLoading}>
              <div className={`${isCreatingLoading ? 'loading loading-spinner' : ''}`}>Add</div>
            </button>
            <button className="btn" onClick={closeModal}>
              Cancel
            </button>
          </div>
        </form>
      </div>
      <form method="dialog" className="modal-backdrop absolute w-full h-full" onClick={closeModal}>
        <button>Close</button>
      </form>
    </dialog>
  );
};

export default AddUserModal;
